const ArrowIcon45 = ({
  className = "",
  width = 20,
  height = 14,
  fill = "none",
}: {
  className?: string;
  width?: number;
  height?: number;
  fill?: string;
}) => {
  return (
    <svg
      className={`${className} hover:stroke-white`}
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.81821 1.18198H3.45425M9.81821 1.18198V7.54594M9.81821 1.18198L4.24975 6.75045M1.33293 9.66726L2.65875 8.34144"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowIcon45;
